'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');

function perfillIfApplies(entry) {
  var _ref = entry || {},
    startTime = _ref.startTime,
    duration = _ref.duration;
  window._perfill = window._perfill || function prefill() {
    window._perfill.q = window._perfill.q || [];
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    window._perfill.q.push(args);
  };
  if (typeof startTime === 'number' && typeof duration === 'number') {
    window._perfill('queue', 'page-render', [{
      metric: 'hydrate-complete',
      value: Math.round(startTime)
    }, {
      metric: 'hydrate-duration',
      value: Math.round(duration)
    }]);
  }
}
var perfill = {
  perfillIfApplies: perfillIfApplies
};
var perfill$1 = _commonjsHelpers.getDefaultExportFromCjs(perfill);

exports.perfill = perfill;
exports.perfill$1 = perfill$1;
